<template>
  <div class="contacto">
    <div class="portada-portafolio">
      <div
        class="subportada-portafolio d-flex align-items-center justify-content-center flex-wrap px-2"
      >
        <div>
          <h1 class="w-100">Contáctanos</h1>
        </div>
      </div>
    </div>
    <div class="contenedor-contacto py-5 ">
      <div class="row w-100 mx-auto">
        <!-- -----Mapa----- -->
        <div class="col-12 col-lg-6">
          <mapa-contacto />
        </div>
        <!-- -------------- -->
        <!-- Información y Formulario -->
        <div class="contacto col-12 col-lg-6 my-2 my-lg-0">
          <div class="w-100 text-center">
            <info-contacto />
          </div>
          <div class="px-0">
            <form-contacto />
          </div>
        </div>
        <!-- ------------------------ -->
        <!-- Img del local -->
        <!-- <localContacto class="col-12 mt-3" /> -->
        <!-- ------------ -->
      </div>
    </div>
  </div>
</template>
<script>
import formContacto from "@/components/cliente/paginas/contacto/formContacto.vue";
import infoContacto from "@/components/cliente/paginas/contacto/infoContacto.vue";
import mapaContacto from "@/components/cliente/paginas/contacto/mapaContacto.vue";
// import localContacto from "@/components/cliente/paginas/contacto/localContacto.vue";
export default {
  components: {
    formContacto,
    infoContacto,
    mapaContacto
    // localContacto
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.portada-portafolio {
  height: 420px;
  min-height: 50vh;
  width: 100%;
  color: white;
  background: #262626;
  background: url("../../assets/images/portadas/contacto.jpeg");
  background-size: cover;
}
.portada-portafolio h1 {
  font-size: calc(3.5em + 1vh);
  letter-spacing: -0.5px;
}

.portada-portafolio h1 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}
.subportada-portafolio {
  background: rgba(0, 0, 0, 0.35);
  height: 100%;
  width: 100%;
}
.contenedor-contacto,
.subportada-portafolio {
  padding: 0 6%;
}
</style>